import { c as _c } from "react/compiler-runtime";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { getDimensionsFromMetadata, getFileTypeFromMetadata } from "@/helpers/nft.helpers";
import NowMintingCountdown from "./NowMintingCountdown";
import NowMintingDetailsAccordion from "./NowMintingDetailsAccordion";
import NowMintingHeader from "./NowMintingHeader";
import NowMintingStatsGrid from "./NowMintingStatsGrid";
interface NowMintingDetailsProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingDetails(t0) {
  const $ = _c(26);
  const {
    nft
  } = t0;
  const formatEth = _temp;
  const floorPrice = formatEth(nft.floor_price);
  let t1;
  if ($[0] !== nft.artist || $[1] !== nft.artist_seize_handle || $[2] !== nft.id || $[3] !== nft.name) {
    t1 = <NowMintingHeader cardNumber={nft.id} title={nft.name} artistHandle={nft.artist_seize_handle} artistName={nft.artist} />;
    $[0] = nft.artist;
    $[1] = nft.artist_seize_handle;
    $[2] = nft.id;
    $[3] = nft.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== floorPrice || $[6] !== nft.id) {
    t2 = <NowMintingStatsGrid nftId={nft.id} floorPrice={floorPrice} />;
    $[5] = floorPrice;
    $[6] = nft.id;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = nft.id;
  const t4 = nft.mint_date;
  let t5;
  if ($[8] !== nft.metadata) {
    t5 = getFileTypeFromMetadata(nft.metadata);
    $[8] = nft.metadata;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== nft.metadata) {
    t6 = getDimensionsFromMetadata(nft.metadata);
    $[10] = nft.metadata;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== nft.collection || $[13] !== nft.id || $[14] !== nft.mint_date || $[15] !== nft.season || $[16] !== t5 || $[17] !== t6) {
    t7 = <NowMintingDetailsAccordion nftId={t3} mintDate={t4} fileType={t5} dimensions={t6} collection={nft.collection} season={nft.season} />;
    $[12] = nft.collection;
    $[13] = nft.id;
    $[14] = nft.mint_date;
    $[15] = nft.season;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== nft.id) {
    t8 = <NowMintingCountdown nftId={nft.id} />;
    $[19] = nft.id;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t1 || $[22] !== t2 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className="tw-w-full"><div className="tw-flex tw-flex-col tw-gap-5">{t1}{t2}{t7}{t8}</div></div>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(value) {
  if (value <= 0) {
    return "N/A";
  }
  return `${Number.parseFloat(value.toFixed(5))} ETH`;
}